<template>
  <div id="template-info">
    <b-row>
      <b-col>
        <div class="d-flex mt-1">
          <b-col cols="3" class="p-0 mr-2">
            <div>
              <label for="toggle" class="required title-name mt-2 font-medium-5"
                >Open/Close</label
              >
            </div>
            <b-form-checkbox
              v-model="formModal.status"
              field-value="true"
              class="custom-control-success custom-toggle"
              name="check-button"
              switch
            >
              <span class="switch-icon-left toggle-text">{{ "Open" }}</span>
              <span class="switch-icon-right toggle-text">{{ "Close" }}</span>
            </b-form-checkbox>
          </b-col>
          <!-- <b-col cols="3" class="p-0 mr-2">
            <div>
              <label for="toggle" class="title-name mt-2 font-medium-5"
                >Tracking</label
              >
            </div>
            <b-form-checkbox
              v-model="formModal.tracking"
              field-value="true"
              class="custom-control-success custom-toggle"
              name="check-button"
              switch
            >
              <span class="switch-icon-left toggle-text">{{ "Track" }}</span>
              <span class="switch-icon-right toggle-text">{{
                "Not Track"
              }}</span>
            </b-form-checkbox>
          </b-col> -->
        </div>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <label for="title" class="required title-name mt-2 font-medium-5"
            >Title</label
          >
          <b-form-input id="title" v-model="formModal.title" required />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <div>
          <label for="choose-privilege" class="title-name mt-1 font-medium-5"
            >Choose Privilege</label
          >
        </div>
      </b-col>

      <b-col cols="6">
        <div>
          <b-button
            class="btn-choose-privilege w-100"
            @click="openChoosePrivilegeModal"
          >
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ "Choose Privilege" }}</span>
            </div>
          </b-button>
        </div>
        <div class="mt-2">
          <div class="privilege-choose-wrp">
            <div
              class="privilege-choose"
              :style="
                formModal.privilegeSelect.img.url
                  ? `background-image : url(${formModal.privilegeSelect.img.url})`
                  : `background-image : url(${NoImgaeIcon})`
              "
              :class="`${formModal.privilegeSelect.img.url ? 'preview' : null}`"
            />
            <div class="pl-1 pr-1 privilege-detail">
              <div class="text-privilege-ref">
                {{ formModal.privilegeSelect.ref || "Privilege Reference" }}
              </div>
              <div class="text-privilege-name">
                {{ formModal.privilegeSelect.name || "Privilege Name" }}
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="6">
        <div class="d-flex align-items-center">
          <b-button
            class="w-100 mr-2"
            :class="
              !formModal.privilegeSelect.id
                ? 'btn-select-image-disabled'
                : 'btn-upload-image'
            "
            @click="openCropImageModal"
          >
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ "Upload Image" }}</span>
            </div>
          </b-button>
          <div>OR</div>
          <b-button
            class="w-100 ml-2"
            :class="
              !formModal.privilegeSelect.id
                ? 'btn-select-image-disabled'
                : 'btn-select-image'
            "
            @click="openSelectPrivilegeModal"
          >
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ "Selece Image" }}</span>
            </div>
          </b-button>
        </div>
         <div class="mt-2" v-if="formModal.privilegeImg.imgUpload.url">
          <div>
            <div class="w-100">
              <div
                class="coupon-img"
                :style="
                  formModal.privilegeImg.imgUpload.url
                    ? `background-image : url(${formModal.privilegeImg.imgUpload.url})`
                    : `background-image : url(${NoImgaeIcon})`
                "
                :class="`${
                  formModal.privilegeImg.imgUpload.url ? 'preview-image ' : null
                }`"
              />
            </div>
          </div>
        </div>
        <div class="mt-2" v-else>
          <div>
            <div class="w-100">
              <div
                class="coupon-img"
                :style="
                  formModal.privilegeImg.img.url
                    ? `background-image : url(${formModal.privilegeImg.img.url})`
                    : `background-image : url(${NoImgaeIcon})`
                "
                :class="`${
                  formModal.privilegeImg.img.url ? 'preview-image ' : null
                }`"
              />
            </div>
          </div>
        </div>
      </b-col>

      <b-col cols="12" class="mt-1">
        <div>
          <div class="d-flex mt-2">
            <b-col class="p-0 mr-2">
              <label for="valid-from-date" class="title-name font-medium-5">
                Valid From</label
              >
              <div class="p-0 p-relative mr-2">
                <calendar-picker-icon
                  class="icon-calendar bypass"
                  :class="
                    formModal.validFrom.date ? 'date-selected-icon' : null
                  "
                />
                <flat-pickr
                  :id="'valid-from-date'"
                  v-model="formModal.validFrom.date"
                  class="form-control bg-date"
                  :class="formModal.validFrom.date ? 'date-selected' : null"
                  :config="flatpickrDateConfig"
                  placeholder="-select-"
                  autocomplete="off"
                  @on-open="
                    flatpickrDateConfig.maxDate = formModal.validThrough.date
                  "
                />
              </div>
            </b-col>
            <b-col class="p-0 ml-2">
              <label for="valid-from-date" class="title-name font-medium-5">
                Time</label
              >
              <div class="p-0 p-relative">
                <clock-picker-icon
                  class="icon-calendar date-picker-icon bypass"
                  :class="
                    formModal.validFrom.time ? 'date-selected-icon' : null
                  "
                />
                <flat-pickr
                  id="valid-from-time"
                  v-model="formModal.validFrom.time"
                  class="form-control bg-date"
                  :class="formModal.validFrom.time ? 'date-selected' : null"
                  :config="flatpickrTimeConfig"
                  :placeholder="'-select-'"
                  autocomplete="off"
                  @on-change="
                    () => {
                      if (
                        formModal.validFrom.date ==
                          formModal.validThrough.date &&
                        formModal.validFrom.time > formModal.validThrough.time
                      ) {
                        formModal.validThrough.time = null;
                      }
                    }
                  "
                />
              </div>
            </b-col>
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="d-flex mt-2">
          <b-col class="p-0 mr-2">
            <label for="valid-through-date" class="title-name font-medium-5">
              Valid Through
            </label>
            <div class="p-0 p-relative mr-2">
              <calendar-picker-icon
                class="icon-calendar bypass"
                :class="
                  formModal.validThrough.date ? 'date-selected-icon' : null
                "
              />
              <flat-pickr
                :id="'valid-through-date'"
                v-model="formModal.validThrough.date"
                class="form-control bg-date"
                :class="formModal.validThrough.date ? 'date-selected' : null"
                :config="flatpickrDateConfig"
                placeholder="-select-"
                autocomplete="off"
                @on-open="
                  flatpickrDateConfig.minDate = formModal.validFrom.date
                "
              />
            </div>
          </b-col>
          <b-col class="p-0 ml-2">
            <label for="valid-through-date" class="title-name font-medium-5">
              Time
            </label>
            <div class="p-0 p-relative">
              <clock-picker-icon
                class="icon-calendar date-picker-icon bypass"
                :class="
                  formModal.validThrough.time ? 'date-selected-icon' : null
                "
              />
              <flat-pickr
                id="valid-from-time"
                v-model="formModal.validThrough.time"
                class="form-control bg-date"
                :class="formModal.validThrough.time ? 'date-selected' : null"
                :config="flatpickrTimeConfig"
                :placeholder="'-select-'"
                autocomplete="off"
                @on-open="
                  () => {
                    if (
                      formModal.validFrom.date == formModal.validThrough.date
                    ) {
                      flatpickrTimeConfig.minTime = formModal.validFrom.time;
                    }
                  }
                "
              />
            </div>
          </b-col>
        </div>
      </b-col>
    </b-row>
    <choose-privilege
      v-if="modalType.choosePrivilege"
      :privilege-id="formModal.privilegeSelect.id"
      @onCloseModal="closeChoosePrivilegeModal"
      @onSave="onSave"
    />
    <select-image-modal
      v-if="modalType.selectImgae"
      :privilege-id="formModal.privilegeSelect.id"
      :image-id="formModal.privilegeImg.id"
      @onCloseModal="closeSelectPrivilegeModal"
      @onSaveImage="onSaveImage"
    />
    <image-cropper-modal
      v-if="modalType.cropperImage"
      @onCloseModal="closeCropImageModal"
      :imageUrl="formModal.privilegeImg.imgUpload.url"
      @onCropImage="onCropImage"
    />
  </div>
</template>

<script>
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import flatPickr from "vue-flatpickr-component";
import NoImgaeIcon from "@/assets/images/icons/img.svg";
import ImageCodeTemplate from "../../code-template-list/components/modal/ImageCodeTemplate.vue";

import useInformationTemplate from "../hooks/useInformationTemplate.js";
import ChoosePrivilege from "../modal/ChoosePrivilegeModal.vue";
import SelectImageModal from "../modal/SelectImageModal.vue";
import ImageCropperModal from "../modal/ImageCropperModal.vue";

import { reactive, getCurrentInstance } from "@vue/composition-api";

export default {
  components: {
    CalendarPickerIcon,
    ClockPickerIcon,
    flatPickr,
    ImageCodeTemplate,
    ChoosePrivilege,
    SelectImageModal,
    ImageCropperModal,
  },
  props: {
    formModal: { type: [Object, Array], default: {} },
    imageUrl: String,
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const {
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      resolveDateObject,
      resolveDate,
      resolveTime,

      modalType,
      openChoosePrivilegeModal,
      closeChoosePrivilegeModal,
      openSelectPrivilegeModal,
      closeSelectPrivilegeModal,

      onSave,
      onSaveImage,

      openCropImageModal,
      closeCropImageModal,
      onCropImage
    } = useInformationTemplate(props);

    return {
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      resolveDateObject,
      resolveDate,
      resolveTime,

      modalType,
      openChoosePrivilegeModal,
      closeChoosePrivilegeModal,
      openSelectPrivilegeModal,
      closeSelectPrivilegeModal,

      onSave,
      NoImgaeIcon,
      onSaveImage,

      openCropImageModal,
      closeCropImageModal,
      onCropImage,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/pages/privilege/privilege-code-template/code-template-info.css";
</style>
